module.exports = __webpack_public_path__ + "static/media/gi.89a90842.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/gi.png
// module id = 1861
// module chunks = 0